import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import SwiperController from './controllers/swiper-controller';
import ModalController from './controllers/modal-controller';
import LeafletMapController from './controllers/leaflet-map-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import AccordionController from './controllers/accordion-controller';

require('./gallery');
require('./icons');
require('./fullpage');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('swiper', SwiperController);
application.register('modal', ModalController);
application.register('map', LeafletMapController);
application.register('cookie-bar', CookieBarController);
application.register('accordion', AccordionController);
